var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPetsIconDynamicUpdated = function SvgPetsIconDynamicUpdated(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14691 9.01024C8.3392 7.48888 8.21003 5.55219 7.04787 5.40523C5.88533 5.25804 4.12919 6.95634 3.93705 8.47831C3.74475 9.99967 4.53139 11.3524 5.69394 11.4996C6.85648 11.6468 7.95476 10.5322 8.14706 9.01085L8.14691 9.01024Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6166 13.1743C18.9357 12.2205 17.1697 13.0253 15.9215 13.916C14.6732 14.8067 14.213 16.3023 14.8934 17.2559C15.5743 18.2096 17.1377 18.261 18.3865 17.3701C19.6348 16.4795 20.2974 14.128 19.6172 13.1741L19.6166 13.1743Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93823 9.33332C11.064 10.0057 12.6903 9.35641 13.5706 7.88256C14.4508 6.40871 15.3948 4.39404 14.2686 3.72142C13.1424 3.0488 10.3729 3.97368 9.49283 5.44714C8.61281 6.92061 8.81203 8.6607 9.93785 9.33309L9.93823 9.33332Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7811 12.4154C16.9069 13.0877 18.5332 12.4384 19.4135 10.9646C20.2937 9.49074 19.7946 6.61416 18.6684 5.94154C17.5422 5.26891 16.2158 7.05571 15.3357 8.52918C14.4557 10.0026 14.6549 11.7427 15.7807 12.4151L15.7811 12.4154Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2423 16.5087C13.9384 15.8399 13.8274 15.0984 13.8922 14.3666C14.0009 13.1431 13.4201 11.9076 12.2947 11.2354C11.2422 10.6068 9.98118 10.6314 8.98302 11.1904C8.17651 11.6422 7.28434 11.9287 6.36902 12.0588C4.89025 12.2694 3.71483 13.1401 3.45129 14.3815C3.0854 16.1037 4.61305 17.8876 6.86347 18.3654L6.87451 18.3678C7.54242 18.509 8.14409 18.8684 8.58512 19.3894L8.59249 19.398C10.0802 21.1528 12.3751 21.652 13.718 20.5132C14.7633 19.6268 14.9239 18.0095 14.2423 16.5087Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPetsIconDynamicUpdated, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pets-icon-dynamic-updated.9213ca58.svg";
export { ForwardRef as ReactComponent };